import FormattedCard from './FormattedCard';
import { useEffect } from 'react';
import { useCardLocationContext } from '../internal/CardLocationContext';
import Raven from 'raven-js';
import { Metrics } from '../internal/Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
export function NotImplementedCard({
  cardData,
  CardFormatter
}) {
  const cardLocationContext = useCardLocationContext();
  useEffect(() => {
    Metrics.counter('not-implemented-card-rendered', Object.assign({
      card_type: cardData.definition.cardType,
      location: cardLocationContext.location
    }, cardLocationContext.loggingTag ? {
      logging_tag: cardLocationContext.loggingTag
    } : {})).increment();
    Raven.captureException(new Error(`Card Type "${cardData.definition.cardType}" is not implemented in location "${cardLocationContext.location}".`), {
      extra: {
        location: cardLocationContext.location,
        loggingTag: cardLocationContext.loggingTag,
        cardData
      }
    });
  }, [cardData, cardLocationContext.location, cardLocationContext.loggingTag]);
  return /*#__PURE__*/_jsx(FormattedCard, {
    cardData: cardData,
    CardFormatter: CardFormatter,
    children: /*#__PURE__*/_jsx("p", {
      children: "This card has not been implemented in the registry"
    })
  });
}